var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0BB4CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.414L20.9999 24.4139C21.3904 24.8044 22.0236 24.8044 22.4141 24.4139L27.414 19.414L29.2802 21.2802C29.4377 21.4377 29.707 21.3262 29.707 21.1034V15.957C29.707 15.8189 29.5951 15.707 29.457 15.707H24.3106C24.0878 15.707 23.9763 15.9763 24.1338 16.1338L26 18L21.707 22.293L17.7071 18.2931C17.3166 17.9026 16.6834 17.9026 16.2929 18.2931L9.99997 24.586C9.6095 24.9765 9.6095 25.6095 9.99997 26C10.3904 26.3905 11.0235 26.3905 11.414 26L17 20.414Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvest);
export default __webpack_public_path__ + "static/media/invest.1aed1dc8c187cb4215633ce5e63f22c3.svg";
export { ForwardRef as ReactComponent };